export default "__VITE_ASSET__43pJ3CvW__"